module.exports = __webpack_public_path__ + "static/img/10006C_3_4_R_20190901_fit.1773a56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/10006C_3_4_R_20190901_fit.png
// module id = vx0K
// module chunks = 0